import type { ReactNode } from 'react'
import type { Dimension, FloatAnchor } from '../data/v1'

function resolveDimension(dim: Dimension): string {
	return dim.mode === '%' ? `${dim.percentValue}%` : `${dim.pxValue}px`
}

const ANCHOR_TRANSFORMS: Record<FloatAnchor, string | undefined> = {
	'top-left': undefined,
	'top-center': 'translateX(-50%)',
	'top-right': 'translateX(-100%)',
	'center-left': 'translateY(-50%)',
	'center': 'translate(-50%, -50%)',
	'center-right': 'translate(-100%, -50%)',
	'bottom-left': 'translateY(-100%)',
	'bottom-center': 'translate(-50%, -100%)',
	'bottom-right': 'translate(-100%, -100%)',
}

const ANCHOR_PLACE_ITEMS: Record<FloatAnchor, string> = {
	'top-left': 'start start',
	'top-center': 'start center',
	'top-right': 'start end',
	'center-left': 'center start',
	'center': 'center center',
	'center-right': 'center end',
	'bottom-left': 'end start',
	'bottom-center': 'end center',
	'bottom-right': 'end end',
}

export type FloatWrapperProps = {
	x: Dimension
	y: Dimension
	anchor: FloatAnchor
	children: ReactNode
}

export function FloatWrapper({ x, y, anchor, children }: FloatWrapperProps) {
	return (
		<div
			style={{
				position: 'absolute',
				left: resolveDimension(x),
				top: resolveDimension(y),
				width: '100%',
				overflow: 'visible',
				pointerEvents: 'none',
			}}
		>
			<div
				style={{
					display: 'grid',
					placeItems: ANCHOR_PLACE_ITEMS[anchor],
					width: 'fit-content',
					maxWidth: '100%',
					transform: ANCHOR_TRANSFORMS[anchor],
					pointerEvents: 'auto',
				}}
			>
				{children}
			</div>
		</div>
	)
}
